import DownloadArchive from './DownloadArchive';

export default DownloadArchive;